import { RateQuoteAccessorial } from '../RateQuoteAccessorial';

import { BaseEditQuoteChargeTableItem } from './BaseEditQuoteChargeTableItem';

export class EditQuoteClientChargeTableItem extends BaseEditQuoteChargeTableItem {
  rate: number = 0;

  constructor(opts?: Partial<EditQuoteClientChargeTableItem>) {
    super(opts);

    if (opts?.rate != null) {
      this.rate = opts.rate;
    }
  }

  rateAmount(): number {
    return this.rate;
  }

  toNewRateQuoteAccessorial(): RateQuoteAccessorial {
    return new RateQuoteAccessorial({
      code: this.chargeCode,
      accessorialDescription: this.chargeCode?.name,
      charge: this.rate,
      stopSequenceNumber: this.stopSequenceNumber,
    });
  }
}
